import { Button, Col, Container, Row } from "reactstrap";
import plans_bg_color from "../../src/assets/images/hero_bg.png";
import plans_bg_noice from "../../src/assets/images/hero_Noise.png";
import { useState } from "react";
import { Header } from "./layout/userheader";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import { Formik } from "formik"
import { Field, Form, Formik } from "formik";
import ReactSelect from "react-select";
import { useApi } from "../helper/apiHook";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "reactstrap";
import { policyData } from "../helper/termsAndPolicy";

const PrivacyPolicy = () => {
  const currentLocation = useLocation();
  let loginType: string | undefined | null =
    currentLocation.pathname.split("/")[1];
  if (!["odoo", "QBO", "xero", "zoho", "qbo", "XERO"].includes(loginType)) {
    loginType = undefined;
  }
  console.log("loginType==", loginType);
  if (loginType === "qbo") {
    loginType = "QBO";
  }
  const api = useApi("sendMail", false);
  const [open, setOpen] = useState<any>("");
  const navigate = useNavigate();

  // accordian

  interface AccordionItem {
    title: string;
    content: JSX.Element;
  }


  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleAccordion = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <>
      <Header />
      <section className="plans_hero contact_hero">
        <Container className="h-100">
          <Row className="h-100">
            <Col lg={7} className="plans_main_text">
              <h1>
                Privacy  <span>Policy</span>
              </h1>
            </Col>
          </Row>
        </Container>
        <img className="plans_bg_noice" alt="background" src={plans_bg_noice} />
        <img className="plans_bg_color" alt="background" src={plans_bg_color} />
      </section>
      <section className="contact_us">
        <Container>
          <div className="w-full max-w-2xl mx-auto mt-10 static-accordian">
            {policyData.map((item:any, index:number) => (
              <div key={index} className="border-b mb-2">
                <button
                  onClick={() => toggleAccordion(index)}
                  className="accordian-btn"
                >
                  <span className="font-medium">{item.title}</span>
                  <span className="icon">
                    {openIndex === index ? "-" : "+"}
                  </span>
                </button>
                {openIndex === index && (
                  <div className="p-3 bg-gray-50 text-gray-700 accordian-body">
                    {item.content}
                  </div>
                )}
              </div>
            ))}
          </div>
        </Container>
      </section>
      <section className="plans_about plans_contact_us about_contact_us">
        <Container className="h-100">
          <Row className="h-100 d-flex align-items-center">
            <Col lg={9} className="plans_about_text">
              <h1>Accelerate Your Transformation</h1>
              <p>
                Transform your workflow with lightning-fast, precise file
                conversions today!
              </p>
            </Col>

            <Col lg={3} className="plans_about_img d-flex justify-content-end">
              <Button
                className="btn"
                onClick={() => {
                  const from = currentLocation.state?.from ?? "login"
                  navigate(loginType ? `/${loginType}/${from}` : `/${from}`)
                }}
              >
                Convert Now
              </Button>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
export default PrivacyPolicy;
